<template>
  <div v-if="show" class="modal-overlay" @click.self="closeModal">
    <div class="modal">
      <button class="close-button" @click="closeModal">
        <span>×</span>
      </button>

      <h6>{{ tituloModal }}</h6>
      <p class="description">{{ descricaoModal }}</p>

      <div class="filters-container">
        <div class="search-bar-container">
          <input
            v-model="searchQuery"
            @input="filterCertificados"
            type="text"
            placeholder="Digite CNPJ ou Razão Social..."
            class="search-bar"
          />
        </div>
        <div class="status-filter">
          <label>Filtrar por Status:</label>
          <select v-model="statusFilter" @change="filterCertificados" class="status-select">
            <option value="todos">Todos</option>
            <option value="vencido">Vencido</option>
            <option value="proximo">Próximo ao Vencimento</option>
          </select>
        </div>
      </div>

      <div class="content-container">
        <table class="faturas-table desktop-only" v-if="sortedCertificados.length > 0">
          <thead>
            <tr>
              <th @click="sortTable('cnpj')">CNPJ <span class="sort-arrow" :class="{ active: currentSortColumn === 'cnpj' }">{{ sortArrow('cnpj') }}</span></th>
              <th @click="sortTable('razao')">Razão Social <span class="sort-arrow" :class="{ active: currentSortColumn === 'razao' }">{{ sortArrow('razao') }}</span></th>
              <th @click="sortTable('diasRestantes')">Dias Restantes <span class="sort-arrow" :class="{ active: currentSortColumn === 'diasRestantes' }">{{ sortArrow('diasRestantes') }}</span></th>
              <th @click="sortTable('dataExpiracao')">Data de Expiração <span class="sort-arrow" :class="{ active: currentSortColumn === 'dataExpiracao' }">{{ sortArrow('dataExpiracao') }}</span></th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cert, index) in sortedCertificados" :key="index" :class="getStatusClass(cert)">
              <td>{{ cert.cnpj }}</td>
              <td>{{ cert.razao }}</td>
              <td class="highlight-days">{{ calcularDias(cert.dataExpiracao) }} dias</td>
              <td>{{ formatarData(cert.dataExpiracao) }}</td>
              <td>{{ getStatusText(cert) }}</td>
            </tr>
          </tbody>
        </table>
        <p v-else class="no-data">Nenhum certificado encontrado.</p>

        <div class="faturas-cards mobile-only" v-if="sortedCertificados.length > 0">
          <div v-for="(cert, index) in sortedCertificados" :key="index" class="fatura-card" :class="getStatusClass(cert)">
            <div class="card-header">
              <h3>{{ cert.razao }}</h3>
              <span class="status-badge" :class="getStatusClass(cert)">{{ getStatusText(cert) }}</span>
            </div>
            <div class="card-body">
              <p><strong>CNPJ:</strong> {{ cert.cnpj }}</p>
              <p class="highlight-days"><strong>Dias Restantes:</strong> {{ calcularDias(cert.dataExpiracao) }} dias</p>
              <p><strong>Data de Expiração:</strong> {{ formatarData(cert.dataExpiracao) }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="fixed-footer">
        <button @click="closeModal" class="confirm-button">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalCertificadosVencimento',
  props: {
    certificados: { type: Array, default: () => [] },
    show: { type: Boolean, default: false },
    tituloModal: { type: String, default: 'Certificados Próximos do Vencimento' },
    descricaoModal: { 
      type: String, 
      default: 'Os certificados listados abaixo estão a menos de 15 dias do vencimento. Atualize-os o quanto antes!' 
    }
  },
  data() {
    return {
      searchQuery: '',
      statusFilter: 'todos',
      currentSortColumn: '',
      currentSortDirection: 'asc',
      filteredCertificados: []
    }
  },
  watch: {
    certificados(newValue) {
      this.filteredCertificados = [...newValue]
      this.filterCertificados()
    },
    show(newVal) {
      if (newVal) {
        this.filteredCertificados = [...this.certificados]
        this.filterCertificados()
      } else {
        this.searchQuery = ''
        this.statusFilter = 'todos'
        this.currentSortColumn = ''
        this.currentSortDirection = 'asc'
      }
    }
  },
  mounted() {
    if (this.show) {
      this.filteredCertificados = [...this.certificados]
      this.filterCertificados()
    }
  },
  computed: {
    sortedCertificados() {
      let lista = [...this.filteredCertificados]
      if (this.currentSortColumn) {
        lista.sort((a, b) => {
          let aVal, bVal
          const aDias = this.calcularDias(a.dataExpiracao)
          const bDias = this.calcularDias(b.dataExpiracao)

          switch (this.currentSortColumn) {
            case 'cnpj': aVal = a.cnpj; bVal = b.cnpj; break
            case 'razao': aVal = a.razao; bVal = b.razao; break
            case 'diasRestantes': aVal = aDias; bVal = bDias; break
            case 'dataExpiracao': aVal = new Date(a.dataExpiracao).getTime(); bVal = new Date(b.dataExpiracao).getTime(); break
          }

          if (typeof aVal === 'string') {
            return this.currentSortDirection === 'asc' 
              ? aVal.localeCompare(bVal) 
              : bVal.localeCompare(aVal)
          }
          return this.currentSortDirection === 'asc' ? aVal - bVal : bVal - aVal
        })
      }
      return lista
    }
  },
  methods: {
    closeModal() {
      console.log('Emitindo close-modal')
      this.$emit('close-modal')
    },
    filterCertificados() {
      let filtered = [...this.certificados]
      
      filtered = filtered.filter(cert => cert.status === 'ATIVO')
      
      const query = this.searchQuery.toLowerCase().trim()
      if (query) {
        filtered = filtered.filter(cert => 
          cert.cnpj?.toLowerCase().includes(query) || 
          cert.razao?.toLowerCase().includes(query)
        )
      }

      if (this.statusFilter !== 'todos') {
        filtered = filtered.filter(cert => {
          const dias = this.calcularDias(cert.dataExpiracao)
          return this.statusFilter === 'vencido' ? dias <= 0 : dias > 0
        })
      }

      this.filteredCertificados = filtered
    },
    sortTable(columnKey) {
      if (this.currentSortColumn === columnKey) {
        this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.currentSortColumn = columnKey
        this.currentSortDirection = 'asc'
      }
    },
    sortArrow(column) {
      if (this.currentSortColumn !== column) return '↕'
      return this.currentSortDirection === 'asc' ? '↑' : '↓'
    },
    calcularDias(dataExpiracao) {
      const hoje = new Date()
      const data = new Date(dataExpiracao)
      const diff = Math.ceil((data - hoje) / (1000 * 60 * 60 * 24))
      return diff <= 0 ? 0 : diff
    },
    formatarData(dataExpiracao) {
      const data = new Date(dataExpiracao)
      const dia = String(data.getDate()).padStart(2, '0')
      const mes = String(data.getMonth() + 1).padStart(2, '0')
      const ano = data.getFullYear()
      return `${dia}/${mes}/${ano}`
    },
    getStatusText(cert) {
      const dias = this.calcularDias(cert.dataExpiracao)
      return dias <= 0 ? 'Vencido' : 'Próximo ao Vencimento'
    },
    getStatusClass(cert) {
      return this.calcularDias(cert.dataExpiracao) <= 0 ? 'status-expired' : 'status-near'
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal {
  position: relative;
  background: #ffffff;
  padding: 1rem;
  width: 95%;
  max-width: 1200px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 28px;
  height: 28px;
  border: none;
  background: #f44336;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1rem;
  transition: transform 0.2s, background 0.2s;
}

.close-button:hover {
  transform: scale(1.1);
  background: #d32f2f;
}

h6 {
  font-size: 1.5rem;
  color: #1d4ed8;
  margin: 0 0 0.75rem;
}

.description {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 1rem;
}

.filters-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.search-bar-container {
  flex: 1;
  min-width: 180px;
}

.search-bar {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: border-color 0.3s;
}

.search-bar:focus {
  border-color: #1d4ed8;
  outline: none;
}

.status-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.status-select {
  padding: 0.5rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.9rem;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.3s;
}

.status-select:focus {
  border-color: #1d4ed8;
  outline: none;
}

.content-container {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 1rem;
}

.faturas-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.faturas-table th {
  background: #1d4ed8;
  color: white;
  padding: 0.75rem;
  position: sticky;
  top: 0;
  z-index: 1;
  cursor: pointer;
  transition: background 0.2s;
}

.faturas-table th:hover {
  background: #153e93;
}

.faturas-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #eee;
  word-break: break-word;
}

.highlight-days {
  font-weight: bold;
  font-size: 1.1rem;
  color: #d32f2f;
}

.status-expired {
  color: #d32f2f;
  font-weight: 500;
}

.status-near {
  color: #1d4ed8;
}

.faturas-cards {
  display: none;
  gap: 0.75rem;
}

.fatura-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 0.75rem;
  border-left: 4px solid;
  margin-bottom: 0.75rem;
  transition: transform 0.2s;
}

.fatura-card.status-expired {
  border-left-color: #d32f2f;
}

.fatura-card.status-near {
  border-left-color: #1d4ed8;
}

.fatura-card:hover {
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.card-header h3 {
  font-size: 1rem;
  margin: 0;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
}

.status-badge.status-expired {
  background: #ffebee;
}

.status-badge.status-near {
  background: #fff3e0;
}

.card-body p {
  margin: 0.4rem 0;
  font-size: 0.85rem;
}

.fixed-footer {
  padding: 0.75rem;
  background: #f8f9fa;
  border-top: 1px solid #eee;
  text-align: right;
}

.confirm-button {
  background: #1d4ed8;
  color: white;
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}

.confirm-button:hover {
  background: #153e93;
  transform: translateY(-1px);
}

.no-data {
  text-align: center;
  color: #666;
  padding: 0.75rem;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (max-width: 768px) {
  .modal {
    width: 90%;
    padding: 0.75rem;
  }
  .desktop-only { display: none; }
  .faturas-cards { display: flex; flex-direction: column; }
  h6 { font-size: 1.25rem; }
  .description { font-size: 0.85rem; }
  .filters-container {
    flex-direction: column;
  }
  .search-bar-container, .status-filter {
    width: 100%;
  }
  .status-filter label {
    font-size: 0.85rem;
  }
  .fatura-card {
    padding: 0.5rem;
  }
  .card-header h3 {
    font-size: 0.9rem;
    max-width: 65%;
  }
  .status-badge {
    font-size: 0.7rem;
  }
  .card-body p {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .modal {
    width: 95%;
    padding: 0.5rem;
  }
  h6 { font-size: 1.1rem; }
  .description { font-size: 0.8rem; }
  .search-bar, .status-select {
    font-size: 0.8rem;
    padding: 0.4rem;
  }
  .status-filter label {
    font-size: 0.8rem;
  }
  .fatura-card {
    padding: 0.4rem;
  }
  .card-header h3 {
    font-size: 0.85rem;
    max-width: 60%;
  }
  .status-badge {
    font-size: 0.65rem;
  }
  .card-body p {
    font-size: 0.75rem;
  }
  .highlight-days {
    font-size: 0.9rem;
  }
  .confirm-button {
    padding: 0.4rem 1rem;
    font-size: 0.8rem;
  }
}

@media (min-width: 769px) {
  .mobile-only { display: none; }
}
</style>